(function () {
  'use strict';

  // Shipping zone config — rates and thresholds in EUR cents (base currency)
  var ZONES = {
    de:    { rate: 490,  freeThreshold: 10000 },
    eu:    { rate: 1490, freeThreshold: 25000 },
    zone1: { rate: 1890, freeThreshold: 0 },
    zone3: { rate: 1990, freeThreshold: 0 }
  };

  var TRANSLATIONS = {
    de: {
      shippingCost: 'Versand: {cost}',
      freeShipping: 'Kostenloser Versand',
      freeThreshold: 'Noch {remaining} bis kostenloser Versand',
      addForFree: 'Versand: {cost} \u2192 Kostenloser Versand',
      unknownCountry: 'Versandkosten werden beim Checkout berechnet'
    },
    en: {
      shippingCost: 'Shipping: {cost}',
      freeShipping: 'Free shipping',
      freeThreshold: '{remaining} until free shipping',
      addForFree: 'Shipping: {cost} \u2192 Free shipping',
      unknownCountry: 'Shipping calculated at checkout'
    },
    fr: {
      shippingCost: 'Livraison\u00a0: {cost}',
      freeShipping: 'Livraison gratuite',
      freeThreshold: 'Encore {remaining} pour la livraison gratuite',
      addForFree: 'Livraison\u00a0: {cost} \u2192 Livraison gratuite',
      unknownCountry: 'Frais de livraison calcul\u00e9s lors du paiement'
    },
    it: {
      shippingCost: 'Spedizione: {cost}',
      freeShipping: 'Spedizione gratuita',
      freeThreshold: 'Ancora {remaining} per la spedizione gratuita',
      addForFree: 'Spedizione: {cost} \u2192 Spedizione gratuita',
      unknownCountry: 'Spese di spedizione calcolate al checkout'
    },
    es: {
      shippingCost: 'Env\u00edo: {cost}',
      freeShipping: 'Env\u00edo gratis',
      freeThreshold: '{remaining} para env\u00edo gratis',
      addForFree: 'Env\u00edo: {cost} \u2192 Env\u00edo gratis',
      unknownCountry: 'Gastos de env\u00edo calculados al finalizar la compra'
    }
  };

  function formatMoney(cents) {
    var format = theme.settings.currencyCodeEnabled
      ? theme.settings.moneyWithCurrencyFormat
      : theme.settings.moneyFormat;
    return theme.Currency.formatMoney(cents, format);
  }

  function getLang() {
    var lang = (theme.localization && theme.localization.language) || 'en';
    if (lang.indexOf('de') === 0) return 'de';
    if (lang.indexOf('fr') === 0) return 'fr';
    if (lang.indexOf('it') === 0) return 'it';
    if (lang.indexOf('es') === 0) return 'es';
    return 'en';
  }

  /**
   * Get the currency conversion rate from base (EUR) to presentment currency.
   * Shopify exposes this via window.Shopify.currency.rate on multi-currency stores.
   * Returns 1 for EUR or if the rate is unavailable.
   */
  function getCurrencyRate(presentmentCurrency) {
    if (presentmentCurrency === 'EUR') return 1;
    var shopifyCurrency = window.Shopify && window.Shopify.currency;
    if (shopifyCurrency && shopifyCurrency.rate) {
      return parseFloat(shopifyCurrency.rate) || 1;
    }
    return 0; // 0 means: rate unknown, show fallback
  }

  /**
   * Convert EUR cents to presentment currency cents, rounded to nearest 10 cents.
   */
  function convertAmount(eurCents, currencyRate) {
    if (currencyRate === 1) return eurCents;
    var converted = Math.round(eurCents * currencyRate);
    // Round to nearest whole unit (like Shopify's currency rounding)
    return Math.round(converted / 100) * 100;
  }

  if (!customElements.get('shipping-estimate')) {
    customElements.define('shipping-estimate', class extends HTMLElement {
      connectedCallback() {
        this.productPrice = parseInt(this.dataset.productPrice) || 0;
        this.cartTotal = parseInt(this.dataset.cartTotal) || 0;
        this.zoneName = this.dataset.zone || 'unknown';
        this.presentmentCurrency = this.dataset.currency || 'EUR';
        this.t = TRANSLATIONS[getLang()] || TRANSLATIONS.en;

        this._onVariantChange = this._handleVariantChange.bind(this);
        this._onCartUpdate = this._handleCartUpdate.bind(this);

        var form = this.closest('product-info');
        if (form) {
          var productForm = form.querySelector('form[data-type="add-to-cart-form"]');
          if (productForm) {
            this._productForm = productForm;
            productForm.addEventListener('variant:change', this._onVariantChange);
          }
        }

        if (theme.pubsub) {
          this._unsubCart = theme.pubsub.subscribe(
            theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this._onCartUpdate
          );
        }

        // For non-EUR currencies, JS must render immediately
        // (Liquid doesn't have the conversion rate)
        if (this.presentmentCurrency !== 'EUR') {
          this._render();
        }
      }

      disconnectedCallback() {
        if (this._productForm) {
          this._productForm.removeEventListener('variant:change', this._onVariantChange);
        }
        if (this._unsubCart) {
          this._unsubCart();
        }
      }

      _handleVariantChange(event) {
        var variant = event.detail && event.detail.variant;
        if (variant) {
          this.productPrice = variant.price;
          this._render();
        }
      }

      _handleCartUpdate(data) {
        var cart = data && data.cart;
        if (cart && cart.total_price !== undefined) {
          this.cartTotal = cart.total_price;
          this._render();
        }
      }

      _render() {
        var el = this.querySelector('[data-shipping-text]');
        if (!el) return;

        if (this.zoneName === 'unknown') {
          el.innerHTML = this.t.unknownCountry;
          return;
        }

        var zone = ZONES[this.zoneName];
        if (!zone) {
          el.innerHTML = this.t.unknownCountry;
          return;
        }

        // Convert EUR zone values to presentment currency
        var currencyRate = getCurrencyRate(this.presentmentCurrency);

        // If rate is unknown (non-EUR without Shopify.currency.rate), show fallback
        if (currencyRate === 0) {
          el.innerHTML = this.t.unknownCountry;
          return;
        }

        var shippingRate = convertAmount(zone.rate, currencyRate);
        var threshold = zone.freeThreshold > 0
          ? convertAmount(zone.freeThreshold, currencyRate)
          : 0;

        // cart total and product price are already in presentment currency
        var cartFree = threshold > 0 && this.cartTotal >= threshold;
        var newTotal = this.cartTotal + this.productPrice;
        var newFree = threshold > 0 && newTotal >= threshold;
        var remaining = Math.max(0, threshold - this.cartTotal);

        var html = '';

        if (cartFree || (newFree && this.productPrice >= threshold)) {
          html = '\u2713 ' + this.t.freeShipping;
        } else if (newFree) {
          html = this.t.addForFree.replace('{cost}', formatMoney(shippingRate));
        } else {
          html = this.t.shippingCost.replace('{cost}', formatMoney(shippingRate));
          if (threshold > 0 && remaining > 0) {
            var msg = this.t.freeThreshold.replace('{remaining}', formatMoney(remaining));
            html += ' <span style="opacity:0.7">(' + msg + ')</span>';
          }
        }

        el.innerHTML = html;
      }
    });
  }
})();
